import React, { useState } from "react";
import { Layout, Menu, Drawer, Grid } from "antd";
import {
  MenuOutlined,
  DashboardOutlined,
  UserOutlined,
  ProjectOutlined,
  EyeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useNavigate, Outlet, useParams } from "react-router-dom";
import AppHeader from "../Header";

const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const TenantDashboardLayout = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { tenantId } = useParams();

  const menuItems = [
    {
      key: "1",
      icon: <DashboardOutlined />,
      label: "Dashboard",
      onClick: () => navigate(`/tenant/${tenantId}`),
    },
    {
      key: "2",
      icon: <UserOutlined />,
      label: "Users",
      children: [
        {
          key: "2-1",
          icon: <PlusOutlined />,
          label: "Add User",
          onClick: () => navigate(`/tenant/${tenantId}/user/createuser`),
        },
        {
          key: "2-2",
          icon: <EyeOutlined />,
          label: "View Users",
          onClick: () => navigate(`/tenant/${tenantId}/user/viewUser`),
        },
      ],
    },
    {
      key: "3",
      icon: <ProjectOutlined />,
      label: "Companies",
      children: [
        {
          key: "3-1",
          icon: <PlusOutlined />,
          label: "Add Company",
          onClick: () => navigate(`/tenant/${tenantId}/company/create`),
        },
        {
          key: "3-2",
          icon: <EyeOutlined />,
          label: "View Companies",
          onClick: () => navigate(`/tenant/${tenantId}/company/view`),
        },
      ],
    },
   
      {
          key: "8",
          icon: <ProjectOutlined />,
          label: "Reports",
          // onClick: () => navigate("/users"),
          children: [
            {
              key: "8-1",
              icon: <PlusOutlined />,
              label: "company Revenue",
              onClick: () => navigate(`/tenant/${tenantId}/reports/companyRevenue`),
            },
            {
              key: "8-2",
              icon: <PlusOutlined />,
              label: "Staff report",
              onClick: () => navigate(`/tenant/${tenantId}/reports/staffReport`),
            },
            {
              key: "8-3",
              icon: <PlusOutlined />,
              label: "Expense report",
              onClick: () => navigate(`/tenant/${tenantId}/reports/expenseReport`),
            },
         
            // {
            //   key: "8-2",
            //   icon: <PlusOutlined />,
            //   label: "Tenant Revenue",
            //   onClick: () => navigate(`/tenant/${tenantId}reports/tenantRevenue`),
            // },
            // {
            //   key: "8-3",
            //   icon: <PlusOutlined />,
            //   label: "letf Plot sale",
            //   onClick: () => navigate("/reports/leftTeamPlot"),
            // },
            // {
            //   key: "8-4",
            //   icon: <PlusOutlined />,
            //   label: "Right plot sale",
            //   onClick: () => navigate("/reports/rightTeamPlot"),
            // },
            // {
            //   key: "8-2",
            //   icon: <EyeOutlined />,
            //   label: "View Projects",
            //   onClick: () => navigate("/project/view"),
            // },
          ],
        },
         {
      key: "10",
      icon: <ProjectOutlined />,
      label: "Settings",
      onClick: () => navigate(`/tenant/${tenantId}/settings`),
    },
     {
      key: "11",
      icon: <ProjectOutlined />,
      label: "Discount",
      onClick: () => navigate(`/tenant/${tenantId}/discount`),
    }

    
        
  ];

  const renderMenu = () => (
    <Menu theme="dark" mode="inline" items={menuItems} />
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {screens.md ? (
        <Sider collapsible>{renderMenu()}</Sider>
      ) : (
        <Drawer
          title="Menu"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          {renderMenu()}
        </Drawer>
      )}
      <Layout>
        <AppHeader onMenuClick={() => setDrawerVisible(true)} />
        <Content style={{ margin: "16px" }}>
          <div
            style={{
              padding: 24,
              background: "#fff",
              minHeight: 360,
              borderRadius: 8,
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default TenantDashboardLayout;
